export default {
  mainApps: {
    shenyue: {
      themeColor: '#1890ff',
      baseURL: 'https://preplatform-api.jilingshu.com.cn',
      apiPrefix: '/backend/resource'
    },
    teacherPlatform: {
      themeColor: '#1ec38f',
      baseURL: 'https://preuser-api.jilingshu.com.cn',
      apiPrefix: '/teacher/resource'
    },
    schoolPlatform: {
      themeColor: '#1ec38f',
      baseURL: 'https://preuser-api.jilingshu.com.cn/',
      apiPrefix: '/teacher/resource'
    },
    institutionPlatform: {
      themeColor: '#1890ff',
      baseURL: 'https://preresource-center.jilingshu.com.cn',
      apiPrefix: ''
    },
    // 通用服务接口调用相关配置
    commonService: {
      baseURL: 'https://pregateway.jilingshu.com.cn',
      apiPrefix: '/api/common-service'
    },
    questionsBank: {
      baseURL: 'https://preexam-center-service.jilingshu.com.cn',
      apiPrefix: ''
    }
  },
  serverURL: 'https://preresource.jilingshu.com.cn',
  pptist: {
    name: 'pptist',
    entry: 'https://preppt.jilingshu.com.cn'
    // entry: 'http://localhost:8090'
  },
  knowledgePoint: {
    name: 'knowledgePoint',
    entry: 'https://preppt.jilingshu.com.cn'
  },
  musicScore: 'https://premusic-score.jilingshu.com.cn'
}
